'use client';
import React, { useState } from 'react';
import Link from 'next/link';

interface Event {
  id: number;
  title: string;
  subtitle: string;
  category: string;
  categoryId: string;
  date: string;
  location: string;
  price: string;
  image: string;
  alt: string;
  badge?: string;
  badgeColor?: string;
}

const events: Event[] = [
{
  id: 1,
  title: 'Neon Nights Music Festival',
  subtitle: 'Outdoor festival. 5 stages. 3 days.',
  category: 'Music',
  categoryId: 'music',
  date: 'Sat, Mar 15, 2025',
  location: 'Central Park, New York',
  price: 'From $49',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1d05647e2-1773042331516.png',
  alt: 'Outdoor music festival at night with colorful neon lights and crowd',
  badge: 'NEW',
  badgeColor: '#8B1A1A'
},
{
  id: 2,
  title: 'AI & Future Tech Summit',
  subtitle: '200+ speakers. 3 days of innovation.',
  category: 'Tech',
  categoryId: 'tech',
  date: 'Thu, Mar 20, 2025',
  location: 'Moscone Center, San Francisco',
  price: 'From $199',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_18764e407-1764659717780.png',
  alt: 'Technology conference with futuristic AI robot on stage',
  badge: 'FEATURED',
  badgeColor: '#1A2A4A'
},
{
  id: 3,
  title: 'International Food & Wine Expo',
  subtitle: '500+ vendors. Unlimited discovery.',
  category: 'Food & Drink',
  categoryId: 'food',
  date: 'Fri, Mar 28, 2025',
  location: 'Navy Pier, Chicago',
  price: 'From $35',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_49dcdd5af-1788536546063.png',
  alt: 'International food expo with colorful dishes and wine glasses on display'
},
{
  id: 4,
  title: 'NBA All-Star Weekend',
  subtitle: 'Live basketball. Packed arena. Unforgettable.',
  category: 'Sports',
  categoryId: 'sports',
  date: 'Sat, Apr 5, 2025',
  location: 'Chase Center, San Francisco',
  price: 'From $150',
  image: "https://images.unsplash.com/photo-1548186746-17a15552b865",
  alt: 'NBA basketball game with packed arena and bright court lights',
  badge: 'HOT',
  badgeColor: '#6B3A1A'
},
{
  id: 5,
  title: 'Contemporary Art Biennale',
  subtitle: 'Immersive installations. Bold creativity.',
  category: 'Arts & Culture',
  categoryId: 'arts',
  date: 'Sun, Apr 13, 2025',
  location: 'MOMA, New York',
  price: 'From $25',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_173ca5469-1775784550403.png',
  alt: 'Modern art museum gallery with colorful abstract paintings on white walls'
},
{
  id: 6,
  title: 'Startup Pitch Night',
  subtitle: 'Meet founders. Network. Get inspired.',
  category: 'Business',
  categoryId: 'business',
  date: 'Wed, Apr 16, 2025',
  location: 'WeWork HQ, Austin',
  price: 'Free',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_136ebe11f-1764672595819.png',
  alt: 'Startup pitch event with entrepreneur presenting to investors in modern office',
  badge: 'FREE',
  badgeColor: '#1A3A2A'
},
{
  id: 7,
  title: 'Yoga & Mindfulness Retreat',
  subtitle: 'Reconnect. Recharge. Renew.',
  category: 'Health & Wellness',
  categoryId: 'wellness',
  date: 'Sat, Apr 19, 2025',
  location: 'Malibu Beach Resort, CA',
  price: 'From $89',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1c573d53b-1767444088653.png',
  alt: 'Group yoga session on beach at sunrise with peaceful ocean backdrop'
},
{
  id: 8,
  title: 'Stand-Up Comedy Gala',
  subtitle: 'Top comedians. One unforgettable night.',
  category: 'Comedy',
  categoryId: 'comedy',
  date: 'Fri, Apr 25, 2025',
  location: 'Comedy Cellar, New York',
  price: 'From $45',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1f83fb062-1772555589267.png',
  alt: 'Stand-up comedian performing on stage with spotlight and laughing audience',
  badge: 'SELLING FAST',
  badgeColor: '#6B4A1A'
},
{
  id: 9,
  title: 'Electronic Music Marathon',
  subtitle: 'All-night DJ sets. Immersive visuals.',
  category: 'Music',
  categoryId: 'music',
  date: 'Sat, May 3, 2025',
  location: 'Brooklyn Mirage, NY',
  price: 'From $65',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_19a105464-1772982268349.png',
  alt: 'Electronic music event with DJ performing under colorful laser light show'
},
{
  id: 10,
  title: 'Web3 & Blockchain Forum',
  subtitle: 'The future of finance. Explore. Connect.',
  category: 'Tech',
  categoryId: 'tech',
  date: 'Mon, May 12, 2025',
  location: 'Miami Beach Convention, FL',
  price: 'From $299',
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1a10dbeed-1764671295977.png',
  alt: 'Blockchain technology conference with digital screens showing crypto charts'
},
{
  id: 11,
  title: 'Family Fun Carnival',
  subtitle: 'Rides, games, and memories for all ages.',
  category: 'Family',
  categoryId: 'family',
  date: 'Sun, May 18, 2025',
  location: 'Riverside Park, Los Angeles',
  price: 'From $15',
  image: "https://images.unsplash.com/photo-1634299570775-25f609e09339",
  alt: 'Colorful family carnival with rides, games, and happy children',
  badge: 'FAMILY',
  badgeColor: '#1A3A2A'
},
{
  id: 12,
  title: 'Outdoor Adventure Run',
  subtitle: '10K trail run through scenic mountain paths.',
  category: 'Outdoor',
  categoryId: 'outdoor',
  date: 'Sat, May 24, 2025',
  location: 'Rocky Mountain Park, CO',
  price: 'From $30',
  image: "https://images.unsplash.com/photo-1560843552-d4bbb846a8d8",
  alt: 'Outdoor adventure hiking group on mountain trail with scenic view'
}];


interface EventGridProps {
  activeCategory?: string;
}

export default function EventGrid({ activeCategory = 'all' }: EventGridProps) {
  const [showAll, setShowAll] = useState(false);

  const filtered =
  activeCategory === 'all' ?
  events :
  events.filter((e) => e.categoryId === activeCategory);

  const displayed = showAll ? filtered : filtered.slice(0, 6);

  return (
    <div className="py-10" style={{ background: '#FAF7F2' }}>
      <div style={{ margin: '0 48px' }}>
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-6">
          <div style={{ width: '3px', height: '28px', background: 'linear-gradient(to bottom, #C9A84C, #8B6914)', borderRadius: '2px' }} />
          <h2
            className="text-2xl font-bold"
            style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#1A0A00' }}>
            
            Innovative experiences for every interest.
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {displayed.map((event) =>
          <div
            key={event.id}
            className="group relative overflow-hidden transition-all duration-300 hover:-translate-y-1"
            style={{
              background: '#FFFFFF',
              borderRadius: '12px',
              border: '1px solid rgba(201,168,76,0.15)',
              boxShadow: '0 2px 8px rgba(26,10,0,0.06)',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 8px 24px rgba(26,10,0,0.12), 0 0 0 1px rgba(201,168,76,0.25)')}
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 8px rgba(26,10,0,0.06)')}>
            
              {/* Image */}
              <div className="relative overflow-hidden" style={{ height: '200px' }}>
                <img
                src={event.image}
                alt={event.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              
                {event.badge &&
              <div
                className="absolute top-3 left-3 px-2 py-0.5 text-xs font-bold"
                style={{
                  background: event.badgeColor,
                  color: '#E8C97A',
                  borderRadius: '4px',
                  letterSpacing: '0.8px',
                  fontFamily: 'Roboto, sans-serif',
                  border: '1px solid rgba(201,168,76,0.3)',
                }}>
                
                    {event.badge}
                  </div>
              }
              </div>

              {/* Content */}
              <div className="p-4">
                <div className="mb-1">
                  <span
                  className="text-xs font-medium"
                  style={{ color: '#C9A84C', fontFamily: 'Roboto, sans-serif', letterSpacing: '0.5px' }}>
                  
                    {event.category}
                  </span>
                </div>
                <h3
                className="font-bold mb-1 leading-snug"
                style={{ fontSize: '15px', fontFamily: '"Playfair Display", Georgia, serif', color: '#1A0A00' }}>
                
                  {event.title}
                </h3>
                <p className="text-sm mb-3" style={{ color: '#8B7355' }}>{event.subtitle}</p>

                <div className="flex items-center gap-2 mb-1">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <rect x="0.5" y="1" width="11" height="10" rx="1.5" stroke="#C9A84C" strokeWidth="1" />
                    <path d="M0.5 4H11.5" stroke="#C9A84C" strokeWidth="1" />
                    <path d="M3.5 0.5V2" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round" />
                    <path d="M8.5 0.5V2" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round" />
                  </svg>
                  <span className="text-xs" style={{ color: '#8B7355' }}>{event.date}</span>
                </div>
                <div className="flex items-center gap-2 mb-4">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M6 1C4.07 1 2.5 2.57 2.5 4.5C2.5 7 6 11 6 11C6 11 9.5 7 9.5 4.5C9.5 2.57 7.93 1 6 1Z" stroke="#C9A84C" strokeWidth="1" />
                    <circle cx="6" cy="4.5" r="1.2" stroke="#C9A84C" strokeWidth="1" />
                  </svg>
                  <span className="text-xs" style={{ color: '#8B7355' }}>{event.location}</span>
                </div>

                {/* CTA Buttons */}
                <div className="flex items-center gap-2">
                  <Link
                  href="#learn"
                  className="flex items-center justify-center h-8 px-4 text-xs font-medium transition-all duration-200"
                  style={{
                    background: 'transparent',
                    color: '#8B6914',
                    border: 'none',
                    fontSize: '12px',
                    fontWeight: 500,
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px',
                    fontFamily: 'Roboto, sans-serif',
                  }}>
                  
                    Learn more
                  </Link>
                  <Link
                  href="#tickets"
                  className="flex items-center justify-center h-8 px-4 text-xs font-medium transition-all duration-200 hover:opacity-90"
                  style={{
                    background: 'linear-gradient(135deg, #C9A84C, #8B6914)',
                    color: '#FAF7F2',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: 500,
                    fontFamily: 'Roboto, sans-serif',
                  }}>
                  
                    {event.price === 'Free' ? 'Register' : 'Buy now'}
                  </Link>
                  <span
                  className="ml-auto text-sm font-bold"
                  style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#1A0A00' }}>
                  
                    {event.price}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* View All Button */}
        {filtered.length > 6 &&
        <div className="flex justify-center mt-8">
            <button
            onClick={() => setShowAll(!showAll)}
            className="flex items-center justify-center h-11 px-10 font-medium text-sm transition-all duration-200 hover:opacity-90"
            style={{
              background: 'transparent',
              color: '#1A0A00',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 500,
              border: '1px solid rgba(201,168,76,0.4)',
              fontFamily: 'Roboto, sans-serif',
              letterSpacing: '0.3px',
            }}>
            
              {showAll ? 'Show less' : 'View all'}
            </button>
          </div>
        }
      </div>
    </div>);

}

